module.exports = __webpack_public_path__ + "static/img/footerParallax.8f57ce90.jpg";